import { CardRarity } from '../cards/cards.ruleset';

// The simple card box drops a set amount of cards
// optionally one of them is guaranteed to be of a certain rarity
type SimpleCardPack = {
  tier: CardPackTier;
  cardsInside: number;
  guaranteedCardTier?: CardRarity;
};

export type CardPackTier = 1 | 2 | 3 | 4 | 5;

type SimpleCardPackID = `card_${CardPackTier}`;

export type CardPackID = SimpleCardPackID;

export const cardPackConfig: Record<CardPackID, SimpleCardPack> = {
  card_1: {
    tier: 1,
    cardsInside: 2,
  },
  card_2: {
    tier: 2,
    cardsInside: 3,
    guaranteedCardTier: 2,
  },
  card_3: {
    tier: 3,
    cardsInside: 4,
    guaranteedCardTier: 3,
  },
  card_4: {
    tier: 4,
    cardsInside: 5,
    guaranteedCardTier: 4,
  },
  card_5: {
    tier: 5,
    cardsInside: 6,
    guaranteedCardTier: 5,
  },
};

export const cardDropProbabilities: Record<CardRarity, number> = {
  1: 0.51,
  2: 0.32,
  3: 0.15,
  4: 0.015,
  5: 0.005,
};
